// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AcoesMarketing_SalvarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /marketing/acoes/salvar (Full, Franqueado, Gerente).
 * `id` absent = create. Wire names ARE the column names of `acoes_marketing`.
 */
import { registerContract } from './validate'

export interface AcoesMarketing_SalvarInput {
acao_franquia_id: number
acao_data: string
acao_nome: string
acao_tipo: string
id?: number
acao_link?: string
acao_descricao?: string
galeria?: undefined[]
}

registerContract('AcoesMarketing_SalvarInput', {
  acao_franquia_id: { type: 'number',  required: true },
  acao_data:        { type: 'string',  required: true },
  acao_nome:        { type: 'string',  required: true },
  acao_tipo:        { type: 'string',  required: true },
  id:               { type: 'number',  required: false },
  acao_link:        { type: 'string',  required: false },
  acao_descricao:   { type: 'string',  required: false },
  galeria:          { type: 'array',   required: false },
})
